import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch } from "react-redux";
import { updateError } from "../../Features/ErrorBoundaryStrategySlice";
import { logError } from "../../Services/ErrorBoundaryStrategyService";
import ErrorFallback from "./ErrorFallback";

/**
 * @description Error handling of the application, triggers if any internal java script error or backend error occurs in the application.
 * @param {node} children child nodes that will render inside the ErrorBoundaryStrategy wrapper.
 * @returns {ReactNode} Render the child nodes on the UI along with the ErrorBoundaryStrategy wrapper and fallback component.
 */

function ErrorBoundaryStrategy({ children }) {
  const dispatch = useDispatch();

  const handleOnError = async (error, errorInfo) => {
    const errorDetails = await logError(error, errorInfo);
    dispatch(updateError(errorDetails));
  };

  return (
    <ErrorBoundary fallback={<ErrorFallback />} onError={handleOnError}>
      {children}
      <ErrorFallback />
    </ErrorBoundary>
  );
}

ErrorBoundaryStrategy.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundaryStrategy;
